import React from 'react';

export const CODE_RESEND_COOLDOWN_SECONDS = 60;

export function formatCountdownSeconds(seconds) {
  const numericSeconds = Number(seconds);
  const remainingSeconds = Number.isFinite(numericSeconds) ? Math.max(Math.floor(numericSeconds), 0) : 0;
  const minutes = Math.floor(remainingSeconds / 60);
  const secondsWithinMinute = remainingSeconds % 60;

  return `${String(minutes).padStart(2, '0')}:${String(secondsWithinMinute).padStart(2, '0')}`;
}

export function formatEmailCodeCooldownMessage(seconds) {
  return `A code was recently sent to this email. Try again in ${formatCountdownSeconds(seconds)}.`;
}

export default function AuthCodeResendControl({ cooldownSeconds, disabled, isResending, onResend }) {
  const isCoolingDown = cooldownSeconds > 0;

  return (
    <div className="mt-12 flex w-full flex-col items-center text-center text-[13px] leading-5 text-black">
      {isCoolingDown ? (
        <p className="m-0">
          Request a new code in: <span className="font-bold">{formatCountdownSeconds(cooldownSeconds)}</span>
        </p>
      ) : null}
      <button
        type="button"
        onClick={onResend}
        disabled={disabled}
        className="cursor-pointer text-[13px] leading-5 text-[#08f] underline underline-offset-2 hover:text-[#0070d5] disabled:cursor-not-allowed disabled:opacity-50"
        data-app-region="none"
      >
        {isResending ? 'Sending...' : 'Send again'}
      </button>
    </div>
  );
}
